<template>     
    <div class="container">
        <div class="row row-40 justify-content-center">         
          <div class="col-sm-10 col-md-6">
            <!-- <h4>{{ checkoutData?.payment_option === 'card' ? 'Credit Card' : 'PayPal' }}</h4> -->
            <div id="paypal-button-container"></div>
          </div>
        </div>
    </div>   
</template>
<script setup>
import { onMounted, nextTick, ref } from 'vue';
import { storeToRefs } from 'pinia'
import { useCartStore } from '@/stores/cart'
import { api } from '@/plugins/axios';
import { useCheckoutStore } from '@/stores/checkoutStore';
import { toast } from 'vue3-toastify'
import router from '@/router'
import { useAuth } from '@/composables/useAuth'
import { useLoaderStore } from '@/stores/loader';
import { useAuthStore } from '@/stores/authStore';

const authStore = useAuthStore()

const loader = useLoaderStore()
const { isAuthenticated } = useAuth()
const checkoutStore = useCheckoutStore()
const cartStore = useCartStore()
const { cart, subtotal } = storeToRefs(cartStore)
const amount = ref(0);

const emit = defineEmits(['update-make-payment'])

const { checkoutData } = defineProps({
  checkoutData: {
    type: Object,
    required: true
  }
})

onMounted(async () => {
  await nextTick() 
  cartStore.loadCart()
  amount.value = subtotal.value; // Use dynamic subtotal as amount

  const script = document.createElement('script');  
  script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PAYPAL_CLIENT_ID}&currency=AUD&locale=en_AU`;
  script.async = true;
  script.onload = () => {
    initPayPalButton();
  };
  document.body.appendChild(script);    
})

const initPayPalButton = () => {
  const fundingSources = checkoutData.payment_option === 'card' ? [paypal.FUNDING.CARD] : [paypal.FUNDING.PAYPAL];

  fundingSources.forEach((fundingSource) => {
    const button = paypal.Buttons({
      fundingSource: fundingSource,
      style: {
        shape: 'pill',
        layout: 'vertical',
        label: 'pay',
      },
      createOrder: async () => {
        try {
          const response = await checkoutStore.createOrder();          
          return response.data.results.paypal_order_id;
        } catch (error) {           
          if(error.response.data.code == 422)                   
          toast.error(error.response.data.results[0] || error.response.data.message)
          throw error;
        }
      },
      onApprove: async (data, actions) => {        
        try {          
          loader.show('Finalizing payment...')
          const response = await checkoutStore.captureOrder(data.orderID);
          if (response.data.results.payment_status === 'COMPLETED') {                  
            localStorage.removeItem('cart')     
            if(isAuthenticated()){
              authStore.user.is_first_online_order = 1
              localStorage.setItem('user', JSON.stringify(authStore.user)) 
              await api.delete('/cart/clear')
            }
            loader.hide()
            toast.success('Payment successful!')
            // Redirect or update UI
            // await router.replace({ name: 'payment-success', params: { id: response.data.results.transaction_id } })
            setTimeout(() => {
              window.location.href = `/payment-success/${response.data.results.transaction_id}`
            }, 3000)            
          }
        } catch (error) {
          console.error(error);
          loader.hide()
          toast.error('Payment capture failed')
          await router.replace({ name: 'payment-failed' })
        }
      },
      onError: async (err) => {        
        // toast.error('An error occurred with PayPal')
        loader.hide()
        console.error(err);
        emit('update-make-payment', false)
      },
    });

    if (button.isEligible()) {
      button.render('#paypal-button-container');
      loader.hide()
    }
  });
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
</style>